export const durationMax = 25;
export const priceMax = 5000;
